import { Message } from "./message";

export class MessageList {
    public __classname__: string = 'MessageList';

    public Messages : Message[] | null = null;
	public ReadMessageIDs : string[] | null = null;
	public DeleteMessageIDs : string[] | null = null;

    constructor(
        Messages : Message[] | null = null, 
        ReadMessageIDs : string[] | null = null, 
        DeleteMessageIDs : string[] | null = null
    ) {
        this.Messages = Messages;
        this.ReadMessageIDs = ReadMessageIDs;
        this.DeleteMessageIDs = DeleteMessageIDs;
    }
}